"use client";

import * as React from "react";
import * as Popover from "@radix-ui/react-popover";
import { cn } from "@/lib/utils";

export interface AppPopoverProps {
  trigger: React.ReactNode;
  children: React.ReactNode;
  align?: "start" | "center" | "end";
  sideOffset?: number;
  width?: string;
  className?: string;
  overlay?: boolean;
  open?: boolean;
  onOpenChange?: (open: boolean) => void;
}

export function AppPopover({
  trigger,
  children,
  align = "end",
  sideOffset = 12,
  width = "w-[min(480px,90vw)]",
  className,
  overlay = false,
  open,
  onOpenChange,
}: AppPopoverProps) {
  return (
    <Popover.Root open={open} onOpenChange={onOpenChange}>
      <Popover.Trigger asChild>{trigger}</Popover.Trigger>
      <Popover.Portal>
        <>
          {overlay && (
            <div className="fixed inset-0 z-40 bg-black/40 data-[state=open]:animate-in data-[state=closed]:animate-out data-[state=closed]:fade-out-0 data-[state=open]:fade-in-0" />
          )}
          <Popover.Content
            align={align}
            sideOffset={sideOffset}
            className={cn(
              "z-50 rounded-2xl overflow-hidden border border-border bg-background shadow-xl",
              "data-[state=open]:animate-in data-[state=closed]:animate-out",
              "data-[state=closed]:fade-out-0 data-[state=open]:fade-in-0",
              "data-[state=closed]:zoom-out-95 data-[state=open]:zoom-in-95",
              width,
              className
            )}
          >
            {children}
          </Popover.Content>
        </>
      </Popover.Portal>
    </Popover.Root>
  );
}
